<script lang="ts">
  import { config } from '../config';
  import { sources } from '../sources';

  const attributions = [
    config.terrain.attribution,
    ...sources.basemaps.list().map((b) => `${b.name}: ${b.attribution}`),
    sources.wind.attribution,
    sources.airspace.attribution,
    sources.geocoder.attribution,
    'Contours generated with <a href="https://github.com/onthegomap/maplibre-contour">maplibre-contour</a>; labels in Noto Sans (SIL OFL)',
    'Maps rendered with <a href="https://maplibre.org/">MapLibre GL JS</a>',
  ];
</script>

<div class="about">
  <h2>Glide Planner</h2>
  <p class="warn">
    <strong>Planning aid only — not for navigation.</strong> Results come from coarse terrain models and an idealised
    glide polar. They ignore sink, turbulence, rotors, thermals and pilot error. Always keep your own margins.
  </p>
  <p>
    Tap the map to set a takeoff and see where you can glide. Tap a coloured cell for its route and profile. Draw
    your own route in <em>Route</em> mode, or find launches for a landing in <em>Region</em> mode. Everything runs
    in your browser; settings stay on this device and plans live in the link.
  </p>
  <h3>Data sources</h3>
  <ul>
    {#each attributions as a (a)}
      <!-- eslint-disable-next-line svelte/no-at-html-tags -- attribution strings are static config -->
      <li>{@html a}</li>
    {/each}
  </ul>
</div>

<style>
  .about h2 {
    margin: 0 0 8px;
  }
  .warn {
    background: #fef3c7;
    border: 1px solid #f59e0b;
    padding: 8px 10px;
    border-radius: 8px;
  }
  ul {
    padding-left: 18px;
    font-size: 13px;
  }
  li {
    margin: 4px 0;
  }
</style>
